import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { LocalStorage, LocalStorageService } from 'ngx-store';

import { AddbookingComponent } from './addbooking/addbooking.component';
// import { AddbookingComponent2 } from './addbooking2/addbooking2.component';

import { ROUTES, RouterModule, Routes } from '@angular/router';
import { FileUploaderModule } from '../control/file-uploader/file-uploader.module';
import { MyDatePickerModule } from 'mydatepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxGeoautocompleteModule } from "ngx-geoautocomplete-v2";
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { ConnoteListComponent } from './connotelist/connotelist.component';
import { ConnoteDetailsComponent } from './connotedetails/connotedetails.component';
import { NgxDaterangepickerMd,DaterangepickerComponent } from 'ngx-daterangepicker-material';

import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../../theme/pipes/pipes.module';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { ClipboardModule } from 'ngx-clipboard';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../../../lib/core/authentication/auth.interceptor';
import { ImportbookingsComponent } from './importbookings/importbookings.component';

import { NotificationsSettingsService } from '../../services/notificationssettings.service';
import { Connotelistv2Component } from './connotelistv2/connotelistv2.component';

import { ComponentsSettingsService } from '../../services/components_settings.service';
import { FilesService } from 'src/app/services/files.service';

// export const routes = [
//   { path: '', redirectTo: 'connotes', pathMatch: 'full'},
//   { path: 'add', component: AddbookingComponent, data: { breadcrumb: 'Add Booking' } },
//   { path: 'connotes', component: ConnoteListComponent, data: { breadcrumb: 'Connotes' } },
//   { path: 'edit/:editId', component: AddbookingComponent, data: { breadcrumb: 'Edit Booking' } },
//   { path: 'rebook/:rebookId', component: AddbookingComponent, data: { breadcrumb: 'Rebook' } },
//   { path: 'connotes/details/:id', component: ConnoteDetailsComponent, data: { breadcrumb: 'Connote Details' } },
//   { path: 'connotes/import', component: ImportbookingsComponent, data: { breadcrumb: 'Import Connotes' } },

//   { path: 'connotesv2', component: Connotelistv2Component, data: { breadcrumb: 'Connotesv2' } },
//   { path: 'connotesv2/details/:id', component: ConnoteDetailsComponent, data: { breadcrumb: 'Connote Details' } },
//   { path: 'connotesv2/import', component: ImportbookingsComponent, data: { breadcrumb: 'Import Connotes' } },

  // { path: 'connotesv2', component: Connotelistv2Component, data: { breadcrumb: 'Connotesv2' } },
  // { path: 'connotesv2/details/:id', redirectTo: 'connotes/details/:id', pathMatch: 'full' },
  // { path: 'connotesv2/import', redirectTo: 'connotes/import', pathMatch: 'full' },
// ];



@NgModule({
  declarations: [AddbookingComponent, ConnoteListComponent,ConnoteDetailsComponent,ImportbookingsComponent, Connotelistv2Component],
  imports: [
    CommonModule,
    RouterModule,
    //RouterModule.forChild(routes),
    FileUploaderModule,
    MyDatePickerModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    ClipboardModule,
    PipesModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MultiselectDropdownModule,
    NgxGeoautocompleteModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0)',
      backdropBorderRadius: '4px',
      primaryColour: '#666666',
      secondaryColour: '#666666',
      tertiaryColour: '#666666'
    }),
    NgxDaterangepickerMd.forRoot()
  ],
  providers: [NotificationsSettingsService, FilesService,
    {
      provide: ROUTES,
      useFactory: (svc_component_settings : ComponentsSettingsService, svc_local_storage: LocalStorageService): Routes => {
        let routes: Routes = [];
        let tms_components = svc_local_storage.get('components');

        if(tms_components){
          tms_components.forEach(item=>{
            switch(item){
              case 'Create Booking' :{ routes.push({ path: 'add', component: AddbookingComponent, data: { breadcrumb: 'Add Booking' }});
                                        // routes.push({ path: 'add2', component: AddbookingComponent2, data: { breadcrumb: 'Add Booking' }}); 
                                      break};

              case 'Connotes' :case 'Jobs' :{ 
                routes.push({ path: '', redirectTo: 'connotesv2', pathMatch: 'full'});
                routes.push({ path: 'connotes', component: ConnoteListComponent, data: { breadcrumb: 'Connotes' } });
                routes.push({ path: 'edit/:editId', component: AddbookingComponent, data: { breadcrumb: 'Edit Booking' } });
                routes.push({ path: 'rebook/:rebookId', component: AddbookingComponent, data: { breadcrumb: 'Rebook' } });
                // routes.push({ path: 'edit2/:editId', component: , data: { breadcrumb: 'Edit Booking' } });
                // routes.push({ path: 'rebook2/:rebookId', component: AddbookingComponent2, data: { breadcrumb: 'Rebook' } });
                routes.push({ path: 'connotes/details/:id', component: ConnoteDetailsComponent, data: { breadcrumb: 'Connote Details' } },);
                routes.push({ path: 'connotesv2', component: Connotelistv2Component, data: { breadcrumb: 'Connotesv2' } });
                routes.push({ path: 'connotesv2/details/:id', redirectTo: 'connotes/details/:id', pathMatch: 'full' });
                break};
              
                case 'Import CSV' :{ 
                routes.push({ path: 'connotes/import', component: ImportbookingsComponent, data: { breadcrumb: 'Import Connotes' } });
                routes.push({ path: 'connotesv2/import', redirectTo: 'connotes/import', pathMatch: 'full'});
                break};
            };
          }); 
        }
        return [...routes];
      },
      deps: [ComponentsSettingsService, LocalStorageService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    }
  ],
  entryComponents: [DaterangepickerComponent]
})
export class BookingsModule { }
